import { always, assoc, dissoc } from 'ramda'
import { createReducer } from '../../utilities/miscellaneous'

// author initial state
export const INITIAL_STATE = {
  isFetching: true,
  current: null,
  articlePages: {},
  error: false,
}

export const FETCH = 'author/FETCH'
export const RECEIVED = 'author/RECEIVED'
export const FETCH_ARTICLE_PAGE = 'author/FETCH_ARTICLE_PAGE'
export const RECEIVED_ARTICLE_PAGE = 'author/RECEIVED_ARTICLE_PAGE'
export const REMOVE_ARTICLE_PAGE = 'author/REMOVE_ARTICLE_PAGE'
export const ERROR = 'author/ERROR'
export const CLEAN = 'author/CLEAN'

// fetch :: () -> Action.FETCH
export const fetch = always({ type: FETCH })

// received :: Author -> Action.RECEIVED
export const received = current => ({
  type: RECEIVED,
  current,
})

// fetchArticlePage :: (Number, Number) -> Action.FETCH_ARTICLE_PAGE
export const fetchArticlePage = (page, size) => ({
  type: FETCH_ARTICLE_PAGE,
  page,
  size,
})

// removeArticlePage :: Number -> Action.REMOVE_ARTICLE_PAGE
export const removeArticlePage = page => ({
  type: REMOVE_ARTICLE_PAGE,
  page,
})

// receivedArticlePage :: (Number, Number, Number, Number, [article]) -> Action.RECEIVED_ARTICLE_PAGE
export const receivedArticlePage = (page, totalPages, scrollHeight, scrollTop, articles = []) => ({
  type: RECEIVED_ARTICLE_PAGE,
  page,
  totalPages,
  scrollHeight,
  scrollTop,
  articles,
})

// error :: () -> Action.ERROR
export const error = always({ type: ERROR })

// clean :: () -> Action.CLEAN
export const clean = always({ type: CLEAN })

export default createReducer(INITIAL_STATE, {
  [FETCH]: state => ({
    ...state,
    isFetching: true,
    error: false,
  }),
  [RECEIVED]: (state, { current }) => ({
    ...state,
    isFetching: false,
    error: false,
    current,
  }),
  [RECEIVED_ARTICLE_PAGE]: (state, { page, articles }) => ({
    ...state,
    articlePages: assoc(page, articles, state.articlePages),
  }),
  [REMOVE_ARTICLE_PAGE]: (state, { page }) => ({
    ...state,
    articlePages: dissoc(page, state.articlePages),
  }),
  [ERROR]: state => ({
    ...state,
    isFetching: false,
    error: true,
  }),
  [CLEAN]: always(INITIAL_STATE),
})
